import { render, staticRenderFns } from "./gerceklesmekurum.vue?vue&type=template&id=460cf88c"
import script from "./gerceklesmekurum.vue?vue&type=script&lang=js"
export * from "./gerceklesmekurum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports